module.exports = __webpack_public_path__ + "img/mangbagja500px.e290db4e.png";